import { useMutation, useQueryClient } from "@tanstack/react-query";

import { useMerchant } from "@/hooks/useMerchant";
import { useTRPC } from "@/trpc/client";

export function useRemoveSubscriptionGuest(
  onSuccess?: () => void,
  onError?: (error: unknown) => void
) {
  const trpc = useTRPC();
  const { merchant } = useMerchant();
  const queryClient = useQueryClient();

  const removeMutation = useMutation({
    ...trpc.subscriptionGuests.inactivate.mutationOptions(),
    onSuccess,
    onError,
  });

  const removeGuest = (documentNumber: string) => {
    if (!merchant?.id) return;

    removeMutation.mutate(
      { rentalsMerchantId: merchant.id, documentNumber },
      {
        onSuccess: () => {
          queryClient.invalidateQueries({
            queryKey: trpc.subscriptionGuests.listActive.queryKey(),
          });
          queryClient.invalidateQueries({
            queryKey: trpc.subscriptions.getMetrics.queryKey({
              rentalsMerchantId: merchant.id,
            }),
          });
        },
      }
    );
  };

  return {
    removeGuest,
    isRemoving: removeMutation.isPending,
    removingDocumentNumber: removeMutation.variables?.documentNumber,
  };
}
